import { DashboardSummary } from "@/components/DashboardSummary";
import { Header } from "@/components/Header";
import { SubscriptionList } from "@/components/SubscriptionList";
import { usePaygStatsPreference } from "@/hooks/usePaygStatsPreference";
import { useViewingPeriod } from "@/hooks/useViewingPeriod";

const Index = () => {
  const periodState = useViewingPeriod();
  const { includePaygInStats, setIncludePaygInStats } =
    usePaygStatsPreference();

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="container space-y-6 py-8">
        <DashboardSummary
          currentPeriod={periodState.currentPeriod}
          onPeriodChange={periodState.setCurrentPeriod}
          onNavigatePeriod={periodState.navigatePeriod}
          onSetToCurrentMonth={periodState.setToCurrentMonth}
          onSetToNextMonth={periodState.setToNextMonth}
          includePaygInStats={includePaygInStats}
          onIncludePaygInStatsChange={setIncludePaygInStats}
        />
        <SubscriptionList
          currentPeriod={periodState.currentPeriod}
          onPeriodChange={periodState.setCurrentPeriod}
          onNavigatePeriod={periodState.navigatePeriod}
          onSetToCurrentMonth={periodState.setToCurrentMonth}
          onSetToNextMonth={periodState.setToNextMonth}
        />
      </main>
    </div>
  );
};

export default Index;
